<template>
    <kt-panel>
      <kt-heading class="px-3" level="1">
          {{ $t('label.bank_management') }}
      </kt-heading>
        <div class="mx-2 my-4">
            <table class="table table-head-solid table-bordered">
                <thead>
                <tr>
                    <th class="text-center">{{$t('status.active')}} / {{$t('status.inactive')}}</th>
                    <th class="text-center">{{$t('label.bank')}}</th>
                    <th class="text-center">{{$t('datatable.actions')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, name, index) in bank_status" :key="index">
                    <td>
                        <AdminBanksActivationCheckboxes
                            :index="index" :name="name" :bank_status="value" :fetch_starshop="fetch_starshop">
                        </AdminBanksActivationCheckboxes>
                    </td>
                    <td class="text-center">{{ $t(`wallets.bank.${name}`) }}</td>
                    <td class="text-center">
                        <div v-if="hasAcToken(name)">
                            <div v-if="typeof value.token === 'object'">
                                <div v-for="(item, item_index) in Object.entries(value.token)" :key="item_index">
                                    <button v-if="!item[1]"
                                            :id="`get_token_${index * 100 + item_index}`"
                                            @click="getToken(name, index * 100 + item_index, item[0])"
                                            class="btn btn-success my-2"
                                    >
                                        <i class="fa fa-arrow-down"></i>
                                        {{$t('label.get_settlement_token') + ' ' + item[0].slice(-4)}}
                                    </button>
                                    <button v-else
                                            :id="`delete_token_${index * 100 + item_index}`"
                                            @click="removeToken(name, index * 100 + item_index, item[0])"
                                            class="btn btn-danger my-2"
                                    >
                                        <i class="fa fa-trash"></i>
                                        {{$t('label.remove_settlement_token') + ' ' + item[0].slice(-4)}}
                                    </button>
                                </div>
                            </div>
                            <div v-else>
                                <button v-if="!value.token" :id="`get_token_${index}`" @click="getToken(name, index)" class="btn btn-success">
                                    <i class="fa fa-arrow-down"></i>
                                    {{$t('label.get_settlement_token')}}
                                </button>
                                <button v-else :id="`delete_token_${index}`" @click="removeToken(name, index)" class="btn btn-danger">
                                    <i class="fa fa-trash"></i>
                                    {{$t('label.remove_settlement_token')}}
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>

            </table>
        </div>
    </kt-panel>
</template>

<script>
import $ from 'jquery'
import {ApiUrl, walletService} from "@/common/api.service";
import {bankId} from "@/constants/bankId";
import {KTApp} from "@/plugins/core/app";
import Checkbox from "@/views/settlement/component/checkbox.vue";
import {i18n} from "@/plugins/i18n";
import AdminBanksActivationCheckboxes
    from "@/views/wallets/AyandeWallets/Admin/components/AdminBanksActivationCheckboxes.vue";

export default {
    props: {
        fetch_starshop: {
            default: false,
            type: Boolean
        },
    },
    name: "bank-token",
    components: {AdminBanksActivationCheckboxes, Checkbox},
    data() {
        return {
            bank_data: [],
            bank_status: [],
            isActive: false,
            total_actual_balance: '',
            total_expected_balance: '',
            actual_balance_and_expected_balance_diff: '',
            expected_balance_is_higher_than_actual: false,
        }
    },
    methods: {
        getToken(driver, index, account = null) {
            if (! this.hasAcToken(driver)) {
                return false;
            }

            let btn = $(`#get_token_${index}`);
            KTApp.progress(btn);

            let params = {
                bank_id: bankId[driver],
                account: account,
            };

            const settlementToken = this.fetch_starshop
                ? walletService.getStarShopSettlementToken
                : walletService.getSettlementToken;

            settlementToken(params).then(res => {
                KTApp.unprogress(btn);
                window.location = res.data.data.url;
            }).finally(() => {
                KTApp.unprogress(btn);
            });
        },
        removeToken(driver, index, account = null) {
            if (this.hasAcToken(driver)) {
                return false;
            }

            let btn = $(`#delete_token_${index}`);
            KTApp.progress(btn);

            let params = {
                bank_id: bankId[driver],
                account: account,
            };

            const removeSettlementToken = this.fetch_starshop
                ? walletService.deleteStarshopSettlementToken
                : walletService.deleteSettlementToken;

            removeSettlementToken(params).then(res => {
                KTApp.unprogress(btn);
                this.checkSettlementToken();
            }).finally(() => {
                KTApp.unprogress(btn);
            });
        },
        checkSettlementToken() {
            let params = {
                wallet_prefix: 'A',
            };
            const bankStatus = this.fetch_starshop
                ? walletService.getStarShopBankStatus
                : walletService.getBankStatus;

            bankStatus(params).then(res => {
                this.bank_status = res.data.data.bank_data;
            });
        },
        changeStatus(val, name) {
            let message = val
                ? i18n.t('message.are_you_sure_to_enable_this_bank')
                : i18n.t('message.are_you_sure_to_disable_this_bank');

            let answer = confirm(message);

            if (!answer) {
                return false;
            }

            $('#id'+name).toggle();

            walletService.changeBankStatus(`${bankId[name]}?active=${val}`).then((response) => {
                this.toastr.success(response.data.message);
            });
        },
        changePayaStatus(val, name) {
            let message = val
                ? i18n.t('message.are_you_sure_to_enable_this_bank')
                : i18n.t('message.are_you_sure_to_disable_this_bank');

            let answer = confirm(message);

            if (!answer) {
                return false;
            }

            walletService.changeBankPayaStatus(`${bankId[name]}?active=${val}`).then((response) => {
                this.toastr.success(response.data.message);
            });
        },
        hasAcToken(driver) {
            return ['pasargad', 'sina', 'ayande', 'parsian'].includes(driver);
        },
    },
    mounted() {
        this.checkSettlementToken();
    },
}
</script>

<style scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #6aad27;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}
.slider.round {
    border-radius: 50px;
}

.slider.round:before {
    border-radius: 50px;
}

.info-icon {
    cursor: pointer;
    color: #0f9af0;
    display: inline-block;
}
</style>
